define("shared/components/shared/profile-categorization/banner", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData
    @socialProfile={{@socialProfile}}
    as |profileReportData|
  >
    {{#if (and profileReportData.hasEnoughPosts (not profileReportData.isLoading))}}
      <div class="o--container o--container--fixed u--p__t" {{did-insert @trackPresentedBannerSelfCat}}>
        {{#if this.isBannerCollapsed}}
          <div
            class="tAN--banner tAN--banner--collapsed tOB--image__categorizationBanner--analyticsSmall u--fadeIn"
            {{on "click" (set this "isBannerCollapsed" false)}}
          >
            <a class="tAN--banner__action" {{on "click" (set this "isBannerCollapsed" false)}}>
              {{svg-jar "nav-down" class="o--icon--sm"}}
            </a>
  
            <div class="tAN--banner__header">
              <div class="tAN--avatar u--m__r">
                <img class="tAN--avatar__img" src="/assets/images/img--selfCat--avatar.png" />
              </div>
              <p class="u--text--md u--m__0">
                {{#if @isPersonal}}
                  {{t "profile_categorization.reports.analytics.banner_title"}}
                {{else}}
                  {{t "profile_categorization.reports.analytics.banner_title_business"}}
                {{/if}}
              </p>
            </div>
          </div>
        {{else}}
          <div class="tAN--banner tOB--image__categorizationBanner--analytics u--fadeIn">
            <a class="tAN--banner__action" {{on "click" (set this "isBannerCollapsed" true)}}>
              {{svg-jar "close" class="o--icon--sm"}}
            </a>
  
            <div class="tAN--banner__header">
              <div class="tAN--avatar u--m__r">
                <img class="tAN--avatar__img" src="/assets/images/img--selfCat--avatar.png" />
              </div>
              <h4 class="u--text--lg u--m__0">
                {{#if @isPersonal}}
                  {{t "profile_categorization.reports.analytics.banner_title"}}
                {{else}}
                  {{t "profile_categorization.reports.analytics.banner_title_business"}}
                {{/if}}
              </h4>
            </div>
  
            <div class="o--btnBar">
              <Shared::Ui::Button
                @onClick={{@openModal}}
                @text={{t "shared_phrases.complete_profile"}}
                @variant="primary"
                class="u--p__lr__lg"
              />
              <Shared::Ui::Button
                @onClick={{this.dismissBanner}}
                @text={{t "shared_words.close"}}
                @variant="mute"
                class="u--p__lr__lg"
              />
            </div>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData>
  */
  {
    "id": "3o1kTkUD",
    "block": "[[[8,[39,0],null,[[\"@socialProfile\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,2],[[30,2,[\"hasEnoughPosts\"]],[28,[37,3],[[30,2,[\"isLoading\"]]],null]],null],[[[1,\"    \"],[11,0],[24,0,\"o--container o--container--fixed u--p__t\"],[4,[38,4],[[30,3]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isBannerCollapsed\"]],[[[1,\"        \"],[11,0],[24,0,\"tAN--banner tAN--banner--collapsed tOB--image__categorizationBanner--analyticsSmall u--fadeIn\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0],\"isBannerCollapsed\",false],null]],null],[12],[1,\"\\n          \"],[11,3],[24,0,\"tAN--banner__action\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0],\"isBannerCollapsed\",false],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"nav-down\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"tAN--banner__header\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"tAN--avatar u--m__r\"],[12],[1,\"\\n              \"],[10,\"img\"],[14,0,\"tAN--avatar__img\"],[14,\"src\",\"/assets/images/img--selfCat--avatar.png\"],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--m__0\"],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"                \"],[1,[28,[35,8],[\"profile_categorization.reports.analytics.banner_title\"],null]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,8],[\"profile_categorization.reports.analytics.banner_title_business\"],null]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"tAN--banner tOB--image__categorizationBanner--analytics u--fadeIn\"],[12],[1,\"\\n          \"],[11,3],[24,0,\"tAN--banner__action\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0],\"isBannerCollapsed\",true],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"close\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"tAN--banner__header\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"tAN--avatar u--m__r\"],[12],[1,\"\\n              \"],[10,\"img\"],[14,0,\"tAN--avatar__img\"],[14,\"src\",\"/assets/images/img--selfCat--avatar.png\"],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"h4\"],[14,0,\"u--text--lg u--m__0\"],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"                \"],[1,[28,[35,8],[\"profile_categorization.reports.analytics.banner_title\"],null]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,8],[\"profile_categorization.reports.analytics.banner_title_business\"],null]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n            \"],[8,[39,9],[[24,0,\"u--p__lr__lg\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,5],[28,[37,8],[\"shared_phrases.complete_profile\"],null],\"primary\"]],null],[1,\"\\n            \"],[8,[39,9],[[24,0,\"u--p__lr__lg\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"dismissBanner\"]],[28,[37,8],[\"shared_words.close\"],null],\"mute\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null]],[2]]]]]],[\"@socialProfile\",\"profileReportData\",\"@trackPresentedBannerSelfCat\",\"@isPersonal\",\"@openModal\"],false,[\"shared/profile-categorization/rewards-steps/provide-profile-report-data\",\"if\",\"and\",\"not\",\"did-insert\",\"on\",\"set\",\"svg-jar\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/profile-categorization/banner.hbs",
    "isStrictMode": false
  });

  let BannerComponent = (_class = class BannerComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "isBannerCollapsed", _descriptor3, this);
    }

    dismissBanner() {
      this.args.trackClickedDismissPrompt();
      const prefix = 'profile_categorization.reports.analytics';
      this.dialogManager.confirm(this.intl.t(`${prefix}.dismiss_banner`), {
        description: this.intl.t(`${prefix}.close_banner_message${this.args.isPersonal ? '' : '_business'}`),
        confirmButton: this.intl.t('shared_words.close'),
        cancelButton: this.intl.t(`${prefix}.cancel`)
      }).then(() => this.args.dismissProfileCategorizePrompt());
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isBannerCollapsed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "dismissBanner", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissBanner"), _class.prototype)), _class);
  _exports.default = BannerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BannerComponent);
});